
import { Vue, Component, Prop } from 'vue-property-decorator';
import TextMenu from '@/components/menu/TextMenu.vue';

@Component<SearchMenuItemResults>({
	components: {
		TextMenu
	}
})
export default class SearchMenuItemResults extends Vue {
	@Prop({ type: String, required: true, default: '' }) private searchText!: string;
	@Prop({ type: Array, required: true, default: () => {} }) private items!: MenuItem[];
	@Prop({ type: String, required: false, default: 'vertical' }) private cardStyle!: string;

	/**
	 * Open the item viewer
	 *
	 * @param {menuItem} menuItem - item id
	 * @return {void}
	 */
	private clickHandler(menuItem: MenuItem): void {
		this.$emit('on-click', menuItem);
	}
}
